import { render, staticRenderFns } from "./PackageCost.vue?vue&type=template&id=34b8c2c8&lang=pug&"
import script from "./PackageCost.vue?vue&type=script&lang=ts&"
export * from "./PackageCost.vue?vue&type=script&lang=ts&"
import style0 from "./PackageCost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports